<script>
export default {
  name: 'user-types',
  computed: {
    userIsAdmin () {
      return this.$store.state.config.user.parent_id === 0;
    },
    userIsWorker () {
      if (!this.$store.state.config.user.id) {
        return true;
      }

      return this.$store.state.config.user.parent_id > 0 && this.$store.state.config.user.worker.worker_type === 0;
    },
    userIsReceptionist () {
      if (!this.$store.state.config.user.id) {
        return true;
      }

      return this.$store.state.config.user.worker && this.$store.state.config.user.worker.worker_type === 1;
    },
    userCanManageOwn () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_manege_own === 1 || this.$store.state.config.permissions.can_manage_own === 1;
    },
    userCanAddReservation () {
      return (!this.userIsReceptionist && !this.userIsWorker) || (this.userIsReceptionist && this.userCanManageOwn) || (this.userIsWorker && this.userCanManageOwn);
    },
    userBlockedTerminsLevel () {
      if (!this.$store.state.config.user.id || !this.$store.state.config.permissions) {
        return 0;
      }

      let level = parseInt(this.$store.state.config.permissions.can_manage_blocked_termins, 10);

      if (isNaN(level) || [0, 1, 2].indexOf(level) === -1) {
        return 2;
      }

      return level;
    },
    userCanAddBlockedTermins () {
      return this.userBlockedTerminsLevel > 0;
    },
    userCanBlockCompanyCalendar () {
      return this.userBlockedTerminsLevel === 2;
    },
    userCanSeeContactData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_contact_data === 1;
    },
    userCanSeePasses () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return !!this.$store.state.config.permissions.can_see_passes_payments;
    },
    userCanSeeFullPaymentsData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_payments === 1 && this.$store.state.config.permissions.can_see_payments_only_for_reservations === 0;
    },
    userCanChangePaymentsStatus () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_change_payment_status === 1 && this.userCanManageOwn;
    },
    userCanSeeLimitedPaymentsData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_payments === 1 && this.$store.state.config.permissions.can_see_payments_only_for_reservations === 1;
    },
    userCanSeeFullSurveysData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_surveys === 1 && this.$store.state.config.permissions.can_see_surveys_only_for_reservations === 0;
    },
    userCanSeeLimitedSurveysData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_surveys === 1 && this.$store.state.config.permissions.can_see_surveys_only_for_reservations === 1;
    },
    userCanSeeFullPassesData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_passes === 1 && this.$store.state.config.permissions.can_see_passes_only_for_reservations === 0;
    },
    userCanSeeLimitedPassesData () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      return this.$store.state.config.permissions.can_see_passes === 1 && this.$store.state.config.permissions.can_see_passes_only_for_reservations === 1;
    },
    userCanManageHours () {
      if (!this.$store.state.config.user.worker.can_manage_hours) {
        return false;
      }

      return this.$store.state.config.user.worker.can_manage_hours === 1;
    },
    userCanManageOwnWorkerExceptions () {
      if (!this.$store.state.config.user.worker.can_manage_worker_exceptions) {
        return false;
      }

      return this.$store.state.config.user.worker.can_manage_worker_exceptions > 0;
    },
    userCanSeeInvoices () {
      if (!this.$store.state.config.user.id) {
        return false;
      }

      if (!this.userCanSeeFullPaymentsData) {
        return false;
      }

      return this.$store.state.config.permissions.fakturownia_api === 1;
    }
  },
  methods: {
    userCanManageBlockedTermin (item) {
      console.log('ITEM:', item);
      if (!item) {
        return false;
      }

      if (item.type !== 'company') {
        return this.userCanAddReservation;
      }

      if (this.userBlockedTerminsLevel === 0) {
        return false;
      }

      if (this.userBlockedTerminsLevel === 2) {
        return true;
      }

      let isWorkerBlockade;

      if (typeof item.blocking_type !== 'undefined' && item.blocking_type !== null) {
        isWorkerBlockade = parseInt(item.blocking_type, 10) === 2;
      } else {
        isWorkerBlockade = !!item.worker && !item.service;
      }

      if (!isWorkerBlockade) {
        return false;
      }

      let workerID = null;

      if (item.worker && typeof item.worker.id !== 'undefined') {
        workerID = item.worker.id;
      } else if (typeof item.worker_id !== 'undefined') {
        workerID = item.worker_id;
      }

      return workerID !== null && parseInt(workerID, 10) === parseInt(this.$store.state.config.user.id, 10);
    },
    currentUserIsAllowedToSee (permissionName) {
      if (!this.$store.state.config.permissions) {
        return false;
      }

      if (permissionName === 'price_rules' && (!this.servicesEnabled || !this.paymentsEnabled)) {
        return false;
      }

      if (permissionName === 'discounts' && (!this.servicesEnabled || !this.paymentsEnabled)) {
        return false;
      }

      if (permissionName === 'payment' && !this.paymentsEnabled) {
        return false;
      }

      if (permissionName === 'sms_history' && !this.smsEnabled) {
        return false;
      }

      if (permissionName === 'customers' && this.$store.state.config.company.customers_based_on === 'no_customers') {
        return false;
      }

      if (permissionName === 'waiting_list' && !this.$store.state.config.company.waiting_list) {
        return false;
      }

      if (permissionName === 'attendances_list' && !this.$store.state.config.company.attendances_list) {
        return false;
      }

      if (permissionName === 'invoices' && !this.invoicesEnabled) {
        return false;
      }

      let specialPermissions = [
        'my_page',
        'services',
        'reservation_parameters',
        'workers',
        'discounts',
        'passes'
      ];

      if (specialPermissions.indexOf(permissionName) > -1) {
        return !!this.$store.state.config.permissions[permissionName] && !!this.$store.state.config.company[permissionName];
      }

      return !!this.$store.state.config.permissions[permissionName];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/UserTypes.vue